<div attr.name="CellOS_{{ item.id }}" class="tCol clickCol desktop" id="CellOS_{{ item.id }}">
    <span *ngIf="notManaged"> </span>
    <span class="image icon-routers" *ngIf="routerManaged"> </span>
    <span class="image icon-services" *ngIf="serviceManaged"> </span>
    <span class="image icon-integrations" *ngIf="clientSyncManaged"> </span>
</div>
